import type { DeviceGenre } from '@/constants/device';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { DEVICE_CATALOGS_PATH } from './key';
export const getDeviceCatalogsForSelect = async (searchText: string, page: number, options?: {
  genres?: DeviceGenre[];
}) => {
  const res = await apiClient.GET(DEVICE_CATALOGS_PATH, {
    params: {
      query: {
        freeText: searchText,
        page,
        pageSize: 20,
        statuses: ['ACTIVE'],
        ...(options?.genres ? {
          genres: options.genres
        } : {})
      }
    }
  });
  return getDataOrThrowApiError(res);
};